import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../../lib/utils/vue3compat/vue_apollo.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import { apolloProvider } from '../../graphql_shared/issuable_client.js?vue3';
import JiraIssuesImportStatusApp from './components/jira_issues_import_status_app.vue?vue3';

export function initJiraIssuesImportStatusRoot() {
  const el = document.querySelector('.js-jira-issues-import-status-root');

  if (!el) {
    return null;
  }

  const { issuesPath, projectPath } = el.dataset;
  const canEdit = parseBoolean(el.dataset.canEdit);
  const isJiraConfigured = parseBoolean(el.dataset.isJiraConfigured);

  if (!isJiraConfigured || !canEdit) {
    return null;
  }

  Vue.use(VueApollo);

  return initVueApp({
    el,
    name: 'JiraIssuesImportStatusRoot',
    apolloProvider,
    component: JiraIssuesImportStatusApp,
    props: {
      issuesPath,
      projectPath,
    },
  });
}
